var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#message_svg__clip0_894_30609)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.4 9.917a5.99 5.99 0 0 0-6-5.994h-8c-3.313 0-6 2.695-6 5.994v12.006h14c3.313 0 6-2.695 6-5.994V9.917Zm-18 10.006V9.917a4.004 4.004 0 0 1 4-3.994h8a3.99 3.99 0 0 1 4 3.994v6.012a4.003 4.003 0 0 1-4 3.994h-12Zm6-8h-2v2h2v-2Zm6 0h-2v2h2v-2Z"
  }))));
};
export default SvgMessage;